import { createTheme } from "@mui/material/styles";
import { TypeText } from "@mui/material/styles/createPalette";
import { color } from '../variables/color'
import { breakpoints } from "../variables/breakpoints";
// declare module '@mui/material/styles' {
//     interface Palette {
//         transparent: string;
//         border?: string
//         symbol?: {
//             ceiling: string,
//             floor: string,
//             reference: string,
//         },
//         table?: {
//             header?: string,
//             odd?: string,
//         },
//         chart?: {
//             series?: string,
//             main?: string
//             violet?: string
//             blue?: string
//             brown?: string
//             yellow?: string
//             red?: string
//             green?: string
//             yellowGreen?: string
//             redDarker?: string
//             greenDarker?: string
//             redLighter?: string
//             greenLighter?: string
//         },
//     }

//     interface PaletteOptions {
//         transparent?: string;
//         border?: string
//         symbol?: {
//             ceiling: string,
//             floor: string,
//             reference: string,
//         }
//         table?: {
//             header?: string,
//             odd?: string,
//         },
//         chart?: {
//             series?: string,
//             main?: string
//             violet?: string
//             blue?: string
//             brown?: string
//             yellow?: string
//             yellowGreen?: string
//             red?: string
//             green?: string
//             redDarker?: string
//             greenDarker?: string
//             redLighter?: string
//             greenLighter?: string
//         },
//     }

//     interface TypeBackground {
//         main?: string
//         input?: string
//         badge?: string
//         backdrop?: string
//         banner?: string
//         menu?: string
//     }

//     interface TypeText {
//         brand?: string
//         up?: string
//         down?: string
//         inherit?: 'inherit'
//     }

// }

export type ColorTypographyElement = keyof TypeText

export default createTheme({
    cssVariables: true,
    typography: {
        fontFamily: 'Roboto, Arial',
    },
    palette: {
        mode: 'light',
        primary: {
            main: color.light.primary,
        },
        secondary: {
            main: color.light.secondary,
        },
        transparent: color.light.transparent,
        background: {
            default: color.light.background.default,
            main: color.light.background.app,
            paper: color.light.background.app,
            input: color.light.background.input,
            badge: color.light.background.badge,
            backdrop: color.light.background.backdrop,
            banner: "#849D301A",
            menu: color.light.background.menu,
        },
        text: {
            primary: color.light.text.primary,
            secondary: color.light.text.secondary,
            disabled: color.light.text.secondary,
            brand: color.light.primary,
            up: color.light.up.main,
            down: color.light.down.main,
            inherit: "inherit",
        },
        border: color.light.secondary,
        symbol: {
            ceiling: color.light.symbol.ceiling,
            floor: color.light.symbol.floor,
            reference: color.light.symbol.reference,
        },
        table: {
            header: color.light.table.header,
            odd: color.light.table.odd,
        },
        chart: {
            main: color.light.primary,
            violet: "#C44AB7",
            blue: "#58BFE0",
            brown: "#A3740D",
            yellow: "#DBC520",
            yellowGreen: "#65A30D",
            red: color.light.down.main,
            green: color.light.up.main,
            redDarker: color.light.down.darker,
            greenDarker: color.light.up.darker,
            redLighter: color.light.down.lighter,
            greenLighter: color.light.up.lighter,
            series: "#FFD700",
        }
    },
    breakpoints: {
        isMobile: breakpoints.isMobile
    },
})